<template>
  <div class="content-430">
    <div class="header-wrapper-430">
      <Form
        ref="addInfoForm"
        :model="addInfo"
        label-position="right"
        :label-width="300"
        :rules="rule"
      >
        <FormItem label="电子收据适用学期：" prop="termCode">
          <CascaderYearTerms
            v-if="(isEdit&&cacheYearTerms.length===2)||!isEdit"
            ref="cascaderYearTerms"
            :cache-year-terms="cacheYearTerms"
            :need-init-data="isEdit?false:true"
            :placeholder="`请选择年度学期`"
            :clearable="false"
            :disabled-year-term="isEdit"
            style="width:300px"
            @on-change="onCascaderChange"
          ></CascaderYearTerms>
          <div class="tips">设置后，年度不可更改！</div>
        </FormItem>
        <FormItem label="协议模板状态：" prop="isEnable">
          <RadioGroup v-model="addInfo.isEnable">
            <Radio v-for="(item,index) in statusList" :key="index" :label="item.status">{{ item.name }}</Radio>
          </RadioGroup>
          <div class="tips">启用后，家长端订购课程成功后，可点击下载收据。</div>
        </FormItem>
        <FormItem label="选择模板：" prop="pdfTemplateFileId">
          <Select v-model="addInfo.pdfTemplateFileId" style="width:300px" @on-change="handleChangeTemplateId">
            <Option v-for="item in templateList" :key="item.codeValue" :value="item.codeValue">{{ item.codeName }}</Option>
          </Select>
        </FormItem>
        <FormItem label="模板示例：">
          <ViewPdfPanel ref="ViewPdfPanel"></ViewPdfPanel>
          <div class="tips">提示：此模板仅做展示作用，实际生成的数据以系统为准。</div>
        </FormItem>
      </Form>
      <!-- <Button></Button> -->
      <div class="btn-block">
        <Button @click="handleToBack">取消</Button>
        <!-- <Button @click="openPreView">预览</Button> -->
        <Button type="primary" @click="handleAddAgreement">提交并关闭</Button>
      </div>
    </div>
    <Modal
      v-model="modal1"
      title="预览"
      width="407"
      footer-hide
    >
      <div class="pre-look">
        <div v-html="htmlShow"></div>
      </div>
    </Modal>
  </div>
</template>
<script>
import CascaderYearTerms from '@c/searchBlock/CascaderYearTerms.vue';
import EditorV5 from '@c/Base/EditorV5';
import ViewPdfPanel from '../assets/components/ViewPdfPanel.vue';
import courseCenterApi from '@/request/courseCenter/courseCenterApi.js';
import platformApi from '@/request/eduCenter/platform.js';
import mixinTableHeight from '@/mixins/mixinTableHeight';
export default {
  components: {
    CascaderYearTerms,
    EditorV5,
    ViewPdfPanel
    // Editor
  },
  mixins: [mixinTableHeight],
  data() {
    return {
      isEdit: false, // 是否是编辑协议
      htmlShow: '',
      modal1: false,
      html: '',
      cacheYearTerms: [],
      addInfo: {
        orgId: this.$route.query.schoolId,
        termCode: '',
        yearCode: '',
        isEnable: 1, // 协议模板状态
        pdfTemplateFileId: '' // 模板id
      },
      statusList: [{
        name: '启用',
        status: 1
      }, {
        name: '停用',
        status: 0
      }],
      signList: [{
        name: '是，必须手写签名',
        status: 1
      }, {
        name: '否，不需要',
        status: 0
      }],
      templateId: 1,
      templateList: [],
      rule: {
        termCode: [
          { required: true, message: '请选择年度学期', trigger: 'change' }
        ],
        isEnable: [
          { required: true, type: 'number', message: '请选择协议模板状态', trigger: 'change' }
        ],
        pdfTemplateFileId: [
          { required: true, message: '请选择模板', trigger: 'change' }
        ]
      },
      editor: null,
      initYear: [],
      stampList: ['#schoolStamp#', '#platStamp#', '#orgStamp#'],
      variableList: [
        {
          name: '学校信息',
          list: [
            {
              name: '学校名称',
              variable: '#schoolName#'
            },
            {
              name: '学校法人',
              variable: '#schoolManger#'
            },
            {
              name: '学校地址',
              variable: '#schoolAddres#'
            }, {
              name: '学校签章',
              variable: '#schoolStamp#'
            }
          ]
        },
        {
          name: '平台信息',
          list: [
            {
              name: '平台名称',
              variable: '#platName#'
            },
            {
              name: '平台法人',
              variable: '#platManager#'
            },
            {
              name: '平台地址',
              variable: '#platAddres#'
            }, {
              name: '平台签章',
              variable: '#platStamp#'
            }
          ]
        },
        {
          name: '机构平台信息',
          list: [
            {
              name: '机构名称',
              variable: '#orgName#'
            },
            {
              name: '机构法人',
              variable: '#orgManager#'
            },
            {
              name: '机构地址',
              variable: '#orgAddres#'
            }, {
              name: '机构签章',
              variable: '#orgStamp#'
            }
          ]
        },
        {
          name: '学生相关信息',
          list: [
            {
              name: '家长真实姓名',
              variable: '#parentTureName#'
            },
            {
              name: '家长身份证号码',
              variable: '#parentIdCard#'
            }, {
              name: '家长手写签名',
              variable: '#parentWriting#'
            }, {
              name: '学生姓名',
              variable: '#studentName#'
            },
            {
              name: '学生年级',
              variable: '#stuGrade#'
            }, {
              name: '学生班级',
              variable: '#stuClass#'
            }
          ]
        },
        {
          name: '订单信息',
          list: [
            {
              name: '订单编号',
              variable: '#payNumber#'
            },
            {
              name: '支付金额（小写）',
              variable: '#paymentAmount#'
            },
            {
              name: '支付金额（大写）',
              variable: '#capitalPaymentAmount#'
            }, {
              name: '支付方式',
              variable: '#payWay#'
            }, {
              name: '支付时间',
              variable: '#chargeTime#'
            }
          ]
        }, {
          name: '商品信息',
          list: [
            {
              name: '课程商品名称',
              variable: '#courseName#'
            },
            {
              name: '课程商品名称&原价',
              variable: '#courseName&price#'
            }
          ]
        }
      ]
    };
  },
  computed: {
    // 可以转换成测试的变量
    variableChangeTestStrList() {
      let list = [];
      this.variableList.forEach(item => {
        const listSmall = item.list.map(x => {
          return x.variable;
        });
        list = list.concat(listSmall);
      });
      list = list.filter(item => {
        return item.indexOf('Stamp') === -1;
      });
      return list;
    }
  },
  created() {
    this.isEdit = +this.$route.query.isEdit === 1;
    if (this.isEdit) {
      this.editFillForm();
    } else {
      this.getTemplateList();
    }
  },
  methods: {
    // 获取电子收据模板列表
    async getTemplateList() {
      const params = {
        codeType: 'ELECTRONIC_RECEIPT_TEMPLATE_PDF_FILE'
      };
      const res = await platformApi.getByCodeType(params);
      if (res.status === 200) {
        this.templateList = res.message;
        (this.addInfo.pdfTemplateFileId === '' && this.templateList.length > 0 && !this.isEdit) ? this.addInfo.pdfTemplateFileId = this.templateList[0].codeValue : '';
        console.log(this.addInfo.pdfTemplateFileId);
        if (this.addInfo.pdfTemplateFileId) {
          this.$nextTick(() => {
            this.$refs.ViewPdfPanel.handleInit(this.addInfo.pdfTemplateFileId);
          });
        }
      }
    },
    // 展示电子收据模板pdf
    handleChangeTemplateId() {
      this.$nextTick(() => {
        this.$refs.ViewPdfPanel.handleInit(this.addInfo.pdfTemplateFileId);
      });
    },
    handleToBack() {
      // console.log(this.$router, this.$route);
      // this.$router.back();
      // 因为页面涉及到iframe嵌套，所以使用window.history.back
      window.history.back();
    },
    // 编辑的话，回填数据
    async editFillForm() {
      console.log(this.$route, '拿到的路由信息---');
      this.addInfo.yearCode = this.$route.query.yearCode;
      this.addInfo.termCode = this.$route.query.termCode;
      this.cacheYearTerms = [+this.addInfo.yearCode, this.addInfo.termCode + ''];
      const params = {
        orgId: this.addInfo.orgId,
        yearCode: this.addInfo.yearCode,
        termCode: this.addInfo.termCode
      };
      const res = await courseCenterApi.getElectronicReceiptDetailApi(params);
      if (res.status === 200) {
        // this.html = res.message.context;
        const { isEnable, pdfTemplateFileId } = res.message;
        this.addInfo.isEnable = isEnable;
        this.addInfo.pdfTemplateFileId = pdfTemplateFileId;
        this.$nextTick(() => {
          this.getTemplateList();
        });
      }
    },
    // 选择年度学期
    onCascaderChange(v) {
      this.addInfo.yearCode = v.length ? v[0] : '';
      this.addInfo.termCode = v.length ? v[1] : '';
    },
    openPreView() {
      this.getHtml();
      if (this.html === '') {
        this.$Message.error('不允许空白文本');
        return;
      }
      this.dealHtmlToShow();
      this.modal1 = true;
    },
    getHtml() {
      this.html = this.$refs.editorV5.getEditorContext();
    },
    dealHtmlToShow() {
      this.htmlShow = this.html;
      this.variableChangeTestStrList.forEach(item => {
        this.htmlShow = this.htmlShow.replace(new RegExp(item, 'gi'), '测试');
      });
      this.stampList.forEach(item => {
        this.htmlShow = this.htmlShow.replace(new RegExp(item, 'gi'), '<img src="https://cjcdn1.gzhtedu.cn/430/mini/image/stamp.png" alt="" data-href="" style="width:30%;height: 30%;vertical-align:top;">');
      });
      // this.htmlShow = this.htmlShow.replace(new RegExp(`<table style="width: auto;">`), `<table style="width: auto;background-size: cover;background-image:url('http://download.gzhtoa.cn:82?fileId=858652699321696256');background-repeat:no-repeat;">`);
      this.htmlShow = `<div style="background-size: cover;background-image:url('https://cjcdn1.gzhtedu.cn/430/mini/image/receipt_templete_bg.png');background-repeat:no-repeat;">${this.htmlShow}</div>`;
      console.log(this.htmlShow);
    },
    // 添加服务协议模板
    handleAddAgreement() {
      this.$refs.addInfoForm.validate((valid) => {
        if (valid) {
          this.isEdit ? this.editAgreement() : this.addAgreement();
        }
      });
    },
    // 在提交给接口之前,把印章变量的前后span去掉
    beforeSubmit(str) {
      let text = str;
      this.stampList.forEach(item => {
        const re = new RegExp('<span[^>]*>' + item + '</span>', 'gi');
        text = text.replace(re, item);
      });
      return text;
    },
    // 编辑服务协议
    async editAgreement() {
      // this.getHtml();
      // if (this.html === '') {
      //   this.$Message.error('不允许空白文本');
      //   return;
      // }

      const params = {
        ...this.addInfo
      };
      const res = await courseCenterApi.updateTemplateApi(params);
      if (res.status === 200) {
        this.$Message.success('编辑成功');
        this.handleToBack();
      }
    },
    async addAgreement() {
      const params = {
        ...this.addInfo
      };
      const res = await courseCenterApi.addTemplateApi(params);
      if (res.status === 200) {
        this.$Message.success('添加成功');
        this.handleToBack();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.tips{
  color: #999;
}
 .btn-block{
    box-sizing: border-box;
    // border-top: 1px solid #ccc;
    background: #fff;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    button+button{
      margin-left: 40px;
    }
  }
.rich-text-block{
  display: flex;
  box-sizing: border-box;
  padding-bottom: 50px;
  position: relative;

  .rich-left{
    width: 18%;
    flex-shrink: 0;
    border: 1px solid #ccc;
    padding: 0 8px 8px 8px;
    height: 100%;
    overflow-y: scroll;
    margin-right: 4%;
    .rich-left-title{
      font-weight: bold;
      font-size: 20px;
      padding: 24px;
      border-bottom: 1px solid #eee;
      text-align: center;
    }
    .left-block-title{
      font-size: 16px;
      color: #999;
      line-height: 24px;
      margin: 16px 0;
    }
    .left-block-item{
      span{
        display: inline-block;
        width: 45%;
        font-size:14px;
        line-height: 20px;
        word-break: break-all;
        vertical-align: top;
      }
      span+span{
        margin-left: 10%;
      }
    }
    .left-block-item+.left-block-item{
      margin-top: 8px;
    }
  }
  .rich-right{
    flex: 1;
    flex-shrink: 0;
    height: 100%;
  }
}

.pre-look{
  height: 650px;
  overflow-y: scroll;
  /deep/table {
    border-top: 1px solid #ccc;
    border-left: 1px solid #ccc;
  }
  /deep/table td,
  table th {
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
    padding: 3px 5px;
  }
  /deep/table th {
    border-bottom: 2px solid #ccc;
    text-align: center;
  }
  .pre-look{
    height: 650px;
    overflow-y: scroll;
    /deep/ html, body, div, span, applet, object, iframe,
      h1, h2, h3, h4, h5, h6, p, blockquote, pre,
      a, abbr, acronym, address, big, cite, code,
      del, dfn, em, img, ins, kbd, q, s, samp,
      small, strike, strong, sub, sup, tt, var,
      b, u, i, center,
      dl, dt, dd, ol, ul, li,
      fieldset, form, label, legend,
      table, caption, tbody, tfoot, thead, tr, th, td,
      article, aside, canvas, details, embed,
      figure, figcaption, footer, header, hgroup,
      menu, nav, output, ruby, section, summary,
      time, mark, audio, video,strong {
        font-family: AliRegular!important;
      }
  }
}
</style>
